import React from 'react';
import { NotificationProps, useNotificationStore } from '@/store/notificationStore';
import { Alert } from '../../Alert';
import styles from './Notification.module.scss';

/**
 * Component that wraps the Alert component.
 * Handles the open/close functionality.
 */
export const Notification: React.FunctionComponent<NotificationProps> = ({ children, type, options = {}, id }) => {
	const timerRef = React.useRef<NodeJS.Timeout>();
	const removeNotification = useNotificationStore((state) => state.removeNotification);

	const handleClose = React.useCallback((): void => {
		if (id) {
			removeNotification(id);
		}
	}, [id, removeNotification]);

	const startTimer = React.useCallback(() => {
		if (options.duration) {
			timerRef.current = setTimeout(handleClose, options.duration);
		}
	}, [options.duration, handleClose]);

	React.useEffect(() => {
		startTimer();

		return (): void => {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
		};
	}, [startTimer]);

	const stopTimer = (): void => {
		if (timerRef.current) {
			clearTimeout(timerRef.current);
		}
	};

	return (
		<div className={styles.item} onMouseEnter={stopTimer} onMouseLeave={startTimer}>
			<Alert type={type} onClose={options.isClosable ? handleClose : undefined}>
				{children}
			</Alert>
		</div>
	);
};
